import { FunctionComponent, useEffect, useState } from 'react';

const formatTime = (date: Date): string => {
  const pad = (number: number): string => {
    const string = String(number);
    return string.length === 1 ? `0${string}` : string;
  };
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${hours}:${minutes}`;
};

export const Time: FunctionComponent = () => {
  const [dateString, setDateString] = useState<string>(formatTime(new Date()));

  useEffect(() => {
    const interval = setInterval(() => {
      setDateString(formatTime(new Date()));
    }, 1000);

    return (): void => {
      clearInterval(interval);
    };
  }, []);

  return <>{dateString}</>;
};
